/* Futuristic X — motion: scroll reveal (stagger) + hero parallax. Dependency-free. */
(function () {
  if (window.__fxMotion) return; window.__fxMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  }
  if (reduce) { showAll(); return; }

  // --- Scroll reveal ---
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -12% 0px' }) : null;

  function bind() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!io) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    els.forEach(function (el) { io.observe(el); });
  }

  // --- Hero parallax ---
  var px = [];
  function collectPx() { px = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')); }
  var ticking = false;
  function update() {
    var y = window.pageYOffset || 0;
    for (var i = 0; i < px.length; i++) {
      var el = px[i];
      var sp = parseFloat(el.getAttribute('data-parallax')) || 0.12;
      el.style.transform = 'translate3d(0,' + (y * sp).toFixed(1) + 'px,0) scale(1.15)';
    }
    ticking = false;
  }
  function onScroll() { if (!ticking) { requestAnimationFrame(update); ticking = true; } }

  function init() {
    bind(); collectPx();
    if (px.length) { window.addEventListener('scroll', onScroll, { passive: true }); update(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function () { bind(); collectPx(); update(); });
})();
